import { render, staticRenderFns } from "./VLabel.vue?vue&type=template&id=fab9b12c&"
import script from "./VLabel.vue?vue&type=script&lang=ts&"
export * from "./VLabel.vue?vue&type=script&lang=ts&"
import style0 from "./VLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports